import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { Injectable } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { MediaObjectModel } from '../../libs/component-lib/components/media-object/media-object.model';
import { FulfilmentStatusConstant } from '../../libs/component-lib/constants/fulfilment-status.constant';
import { EvsbThankYouModel, EvsbThankYouModelItem } from './evsb-thank-you.model';
import { environment } from '@app/env';

@Injectable()
export class EvsbThankYouMapper {
  constructor(private translateService: TranslateService, private analyticsService: AnalyticsService) {}

  public map(): EvsbThankYouModel {
    return {
      title: marker('modules.evcSmallBiz.thankYou.title'),
      alert: this.getAlert(),
      items: this.getItems(),
    };
  }

  private getAlert(): MediaObjectModel {
    return {
      src: './assets/evc/img/contact.svg',
      text: marker('modules.evcSmallBiz.thankYou.alert.text'),
    };
  }

  private getItems(): EvsbThankYouModelItem[] {
    const items = [] as EvsbThankYouModelItem[];

    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYou.fulfilment.1.title`),
      status: FulfilmentStatusConstant.completed,
    });
    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYou.fulfilment.2.title`),
      status: FulfilmentStatusConstant.completed,
    });

    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYou.fulfilment.3.title`),
      text: marker(`modules.evcSmallBiz.thankYou.fulfilment.3.text`),
      status: FulfilmentStatusConstant.progress,
      card: {
        badge: marker(`modules.evcSmallBiz.thankYou.fulfilment.3.card.badge`),
        title: marker(`modules.evcSmallBiz.thankYou.fulfilment.3.card.title`),
        list: [
          marker(`modules.evcSmallBiz.thankYou.fulfilment.3.card.list.1`),
          marker(`modules.evcSmallBiz.thankYou.fulfilment.3.card.list.2`),
        ],
        cta: marker(`modules.evcSmallBiz.thankYou.fulfilment.3.card.cta`),
        ctaClick: () => {
          this.analyticsService.push({
            event: 'cta',
            eventCategory: 'b-to-b-ev-simulator',
            eventAction: 'click-cta-confirmation-screen',
            eventLabel: 'green-energy-simulator',
          });

          const path = `${environment.websiteUrl}${
            environment[
              `simulatorB2B${this.translateService.currentLang.replace(/\b\w/g, (f) => f.toLocaleUpperCase())}`
            ]
          }?promoCode=eMobilityB2B2000`;

          window.open(path, '_blank').focus();
        },
        alert: marker(`modules.evcSmallBiz.thankYou.fulfilment.3.card.alert`),
      },
    });

    items.push({
      completed: false,
      title: marker(`modules.evcSmallBiz.thankYou.fulfilment.4.title`),
      status: FulfilmentStatusConstant.none,
    });
    items.push({
      completed: false,
      title: marker(`modules.evcSmallBiz.thankYou.fulfilment.5.title`),
      status: FulfilmentStatusConstant.none,
    });
    items.push({
      completed: false,
      title: marker(`modules.evcSmallBiz.thankYou.fulfilment.6.title`),
      status: FulfilmentStatusConstant.none,
    });

    return items;
  }
}
